import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AuthenticatedUserFragment = { __typename: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, isStaff: boolean, isSuperuser: boolean, name: string, role?: Types.SystemRole | null, onboardingCompletedAt?: string | null, selfServiceSignup?: boolean | null, startingScreenDismissedAt?: string | null, has3dExperience?: boolean | null, newsletterOptIn: boolean, galleryImage?: { __typename: 'DataObject', id: string } | null, memberships: Array<{ __typename: 'Membership', id: string, role: Types.MembershipRole, organization: { __typename: 'Organization', id: string, name?: string | null, url?: string | null, type?: Types.OrganizationType | null, stripeSubscriptionStatus?: string | null, accountType: Types.AccountType, trialEndsAt?: string | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } }> };

export type AuthSiloDataFragment = { __typename: 'User', id: string, role?: Types.SystemRole | null, memberships: Array<{ __typename: 'Membership', id: string, organization: { __typename: 'Organization', id: string, name?: string | null, url?: string | null, type?: Types.OrganizationType | null, stripeSubscriptionStatus?: string | null, accountType: Types.AccountType, trialEndsAt?: string | null } }> };

export type AuthSiloDataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AuthSiloDataQuery = { __typename: 'Query', user: { __typename: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, isStaff: boolean, isSuperuser: boolean, name: string, role?: Types.SystemRole | null, onboardingCompletedAt?: string | null, selfServiceSignup?: boolean | null, startingScreenDismissedAt?: string | null, has3dExperience?: boolean | null, newsletterOptIn: boolean, galleryImage?: { __typename: 'DataObject', id: string } | null, memberships: Array<{ __typename: 'Membership', id: string, role: Types.MembershipRole, organization: { __typename: 'Organization', id: string, name?: string | null, url?: string | null, type?: Types.OrganizationType | null, stripeSubscriptionStatus?: string | null, accountType: Types.AccountType, trialEndsAt?: string | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } }> } };

export type OrganizationForSiloQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OrganizationForSiloQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, name?: string | null, url?: string | null, type?: Types.OrganizationType | null, stripeSubscriptionStatus?: string | null, accountType: Types.AccountType, trialEndsAt?: string | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } };

export type MembershipForSiloQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MembershipForSiloQuery = { __typename: 'Query', membership: { __typename: 'Membership', id: string, role: Types.MembershipRole, organization: { __typename: 'Organization', id: string, name?: string | null, url?: string | null, stripeSubscriptionStatus?: string | null, accountType: Types.AccountType, trialEndsAt?: string | null, type?: Types.OrganizationType | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } } };

export const AuthenticatedUserFragmentDoc = gql`
    fragment AuthenticatedUser on User {
  id
  __typename
  email
  firstName
  lastName
  isStaff
  isSuperuser
  name
  role
  onboardingCompletedAt
  selfServiceSignup
  startingScreenDismissedAt
  has3dExperience
  newsletterOptIn
  galleryImage {
    id
  }
  memberships {
    id
    role
    organization {
      id
      name
      url
      type
      stripeSubscriptionStatus
      accountType
      trialEndsAt
      organizationGroup {
        id
        organizations {
          id
          name
          isActive
        }
      }
    }
  }
}
    `;
export const AuthSiloDataFragmentDoc = gql`
    fragment AuthSiloData on User {
  id
  __typename
  role
  memberships {
    id
    organization {
      id
      name
      url
      type
      stripeSubscriptionStatus
      accountType
      trialEndsAt
    }
  }
}
    `;
export const AuthSiloDataDocument = gql`
    query authSiloData($id: ID!) {
  user(id: $id) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthSiloDataGQL extends Apollo.Query<AuthSiloDataQuery, AuthSiloDataQueryVariables> {
    override document = AuthSiloDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationForSiloDocument = gql`
    query organizationForSilo($id: ID!) {
  organization(id: $id) {
    id
    name
    url
    type
    stripeSubscriptionStatus
    accountType
    trialEndsAt
    organizationGroup {
      id
      organizations {
        id
        name
        isActive
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationForSiloGQL extends Apollo.Query<OrganizationForSiloQuery, OrganizationForSiloQueryVariables> {
    override document = OrganizationForSiloDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MembershipForSiloDocument = gql`
    query membershipForSilo($id: ID!) {
  membership(id: $id) {
    id
    organization {
      id
      name
      url
      stripeSubscriptionStatus
      accountType
      trialEndsAt
      type
      organizationGroup {
        id
        organizations {
          id
          name
          isActive
        }
      }
    }
    role
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MembershipForSiloGQL extends Apollo.Query<MembershipForSiloQuery, MembershipForSiloQueryVariables> {
    override document = MembershipForSiloDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }